import * as React from "react";
import SeekerStore from "../../../stores/seekerStore";
import LegalStore from "../../../stores/legalStore";
import { ILocalization } from "../../../models/localization";
import { Row, Col } from "react-flexbox-grid";
import * as FontAwesome from "react-fontawesome";
import * as s from "./footer.css";
import Button from "material-ui/Button";

export default class Footer extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    const ls: LegalStore = this.props.store.legal;
    const local: ILocalization = this.props.store.localization.fields;
    if (!local || !ls) {
      return null;
    }
    const fontAwesomeStyle: any = { margin: "10px" };
    const cmpyFacebook: string = local.footer.facebook || "https://www.facebook.com/SkillSmartUS";
    const cmpyTwitter: string = local.footer.twitter || "https://twitter.com/skillsmartus";
    const cmpyLinkedIn: string = local.footer.linkedin || "https://www.linkedin.com/company/skillsmart?trk=biz-companies-cym";

    return <Row className={s.footer}>
      <Col xs={12} sm={6}>
        <div className={s.footerText}>
          <p>{local.copyright} {local.readOur} <a onClick={() => ls.showTermsAndConditions()}>{local.nav.tandc}</a> {local.andFooter} <a onClick={() => ls.showPrivacyStatement()}>{local.nav.privacy}</a>. {local.seeOur} <a onClick={() => ls.showDisclaimerStatement()}>{local.footer.disclaimerHeader}</a>.</p>
        </div>       
      </Col>
      <Col xs={12} sm={6} className={s.socialLinks}>
        <a href={cmpyTwitter} target="_blank"><FontAwesome name="twitter" className="fa-1x" style={fontAwesomeStyle} /></a>
        <a href={cmpyFacebook} target="_blank" ><FontAwesome name="facebook" className="fa-1x" style={fontAwesomeStyle} /></a>
        <a href={cmpyLinkedIn} target="_blank"><FontAwesome name="linkedin" className="fa-1x" style={fontAwesomeStyle} /></a>
      </Col>
    </Row>;
  }
}


// WEBPACK FOOTER //
// ./src/components/app/footer/index.tsx